var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.toolId)?_c('b-popover',{attrs:{"boundary":_setup.boundary,"target":_vm.target,"triggers":"hover"}},[_vm._v("\n    Tool:\n    "),_c(_setup.ToolLink,{attrs:{"tool-id":_vm.toolId,"tool-version":_vm.toolVersion || 'latest'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }